import { render, staticRenderFns } from "./ScrollCarousel.vue?vue&type=template&id=0b294b8c&scoped=true"
import script from "./ScrollCarousel.vue?vue&type=script&lang=js"
export * from "./ScrollCarousel.vue?vue&type=script&lang=js"
import style0 from "./ScrollCarousel.vue?vue&type=style&index=0&id=0b294b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b294b8c",
  null
  
)

export default component.exports